


























































































































































































import config from '@/config/index';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { Funcionalidades } from '@/config/funcionalidades';
import { Bar, Line, Doughnut, Radar } from 'vue-chartjs';
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator';
import { fetchDashboard } from '@/pantallas/Dashboard/fetchDashboard';
import { LoadingService } from '@/services/loadingService';
import { checkboxColumnDef } from '@/reusable/Grid/aggridColumnDefUtils';
import ExportMenu from '@/pantallas/Dashboard/ExportMenu.vue';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  exportCsv,
  exportExcel,
  exportJson,
} from '@/pantallas/Dashboard/ExportFile';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  DragStoppedEvent,
  ColumnVisibleEvent,
  ColumnPinnedEvent,
  CsvExportParams,
  ProcessCellForExportParams,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');

class Graphic {
  labels: string[];
  values: number[];
  patents: string[];
  constructor(labels: string[], values: number[], patents: string[]) {
    this.labels = labels;
    this.values = values;
    this.patents = patents;
  }
  clear() {
    this.labels = [];
    this.values = [];
    this.patents = [];
  }
}

@Component({
  components: {
    barComp: Bar,
    lineComp: Line,
    doughnutComp: Doughnut,
    radarComp: Radar,
    'ag-grid-vue': AgGridVue,
    exportMenu: ExportMenu,
  },
})
export default class DashboardOs extends Vue {
  readonly loadingService = new LoadingService();
  @Prop() load: boolean;

  // State
  types: string[] = [
    'alertGraph',
    'alertGraphDetail',
    'maxSpeed',
    'maxSpeedDetail',
    'kilometersTraveled',
    'kilometersTraveledDetail',
    'useTime',
    'useTimeDetail',
    'ignitionGraph',
    'ignitionGraphDetail',
  ];
  gridOptionSpeed: GridOptions;
  gridOptionDistance: GridOptions;
  gridOptionTime: GridOptions;
  gridOptionIgnition: GridOptions;
  gridOptionAlert: GridOptions;
  sideBar: any = config.agGridDefaultConfig;
  $snotify: any;

  // Pointers
  mousePointAlert: boolean = false;
  mousePointAlertDetail: boolean = false;
  mousePointSpeed: boolean = false;
  mousePointSpeedDetail: boolean = false;
  mousePointDistance: boolean = false;
  mousePointDistanceDetail: boolean = false;
  mousePointTime: boolean = false;
  mousePointTimeDetail: boolean = false;
  mousePointIgnition: boolean = false;
  mousePointIgnitionDetail: boolean = false;

  // Grid
  columnDefsSpeed: any = [];
  columnDefsDistance: any = [];
  columnDefsTime: any = [];
  columnDefsIgnition: any = [];
  columnDefsAlert: any = [];
  rowDataSpeed: [] = [];
  rowDataDistance: [] = [];
  rowDataTime: [] = [];
  rowDataIgnition: [] = [];
  rowDataAlert: [] = [];

  oldPatentValues: string[] = [];
  patentValues: string[] = [];
  oldDateValue: any = '7';
  dateValue: any = '7';
  dateOptions: any = [
    { label: 'Hoy', value: 'now' },
    { label: 'Ayer', value: '1' },
    { label: 'últimos 7 días', value: '7' },
    { label: 'últimos 30 días', value: '30' },
    { label: 'Esta semana', value: 'currentWeek' },
    { label: 'Este mes', value: 'currentMonth' },
    { label: 'Este año', value: 'currentYear' },
    { label: 'última semana', value: 'lastWeek' },
    { label: 'último mes', value: 'lastMonth' },
  ];
  search: any = '';

  // Graphics
  speedGraphic: any = {};
  distanceGraphic: any = {};
  timeGraphic: any = {};
  alertGraphic: any = {};
  ignitionGraphic: any = {};
  pluginOptions: any = {
    datalabels: {
      anchor: 'end',
      align: 'end',
      padding: -3,
      formatter: (val: any) => `${val}`,
      labels: {
        value: {
          color: 'black',
        },
      },
    },
  };
  pluginOptionsTime: any = {
    datalabels: {
      anchor: 'end',
      align: 'end',
      padding: -3,
      formatter: (val: any) => `${val}`,
      labels: {
        value: {
          color: 'black',
        },
      },
    },
  };

  constructor() {
    super();
    this.gridOptionSpeed = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: this.sideBar,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
    };
    this.gridOptionDistance = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: this.sideBar,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
    };
    this.gridOptionTime = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: this.sideBar,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
    };
    this.gridOptionIgnition = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: this.sideBar,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        Fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
    };
    this.gridOptionAlert = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 1000,
      paginationAutoPageSize: false,
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      sideBar: this.sideBar,
      blockLoadDebounceMillis: 350,
      columnTypes: {
        fecha: {
          cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
    };
  }

  fechaFilter(r: any) {
    return this.$options.filters.formatDate(r.value);
  }

  filterActivities() {
    var self = this;
    setTimeout(() => {
      self.loadGraphicFetch();
      self.oldDateValue = self.dateValue;
      self.oldPatentValues = self.patentValues;
    }, 500);
    // if (
    //   JSON.stringify(this.oldDateValue) !== JSON.stringify(this.dateValue) ||
    //   this.oldPatentValues.toString() !== this.patentValues.toString()
    // ) {
    //   this.loadGraphicFetch();
    //   this.oldDateValue = this.dateValue;
    //   this.oldPatentValues = this.patentValues;
    // }
  }

  async loadGraphicFetch() {
    this.clearGraphics();
    this.$emit('notifyLoad', false);
    this.loadingService.showLoading('Por favor espere...', 'dashboardOs');
    let model = {
      nameId: this.getUserID(),
      clienteId: this.getClientID(),
      date: this.dateValue,
      patents: this.patentValues.toString(),
    };

    fetchDashboard(model, "graficos_track3_v2/get_alertas")
      .then((response)=>response.data)
      .then(response => {
        if (response.CODIGO_RESPUESTA != '1') {
          this.$snotify.error(response.MENSAJE_RESPUESTA);
        }else{
          // Lógica
          this.fillData('a_graph', response.data.graph);
          this.fillData('a_det', response.data.det);
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
      });

    fetchDashboard(model, "graficos_track3_v2")
      .then((response)=>response.data)
      .then(response => {
        if (response.CODIGO_RESPUESTA != '1') {
          this.$snotify.error(response.MENSAJE_RESPUESTA);
        }else{
          // Lógica
          for(let key in response.data){
            this.fillData(key, response.data[key]);
          }
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading('dashboardOs');
        this.$emit('notifyLoad', true);
      });

  }

  exportData(type: string, extension: string) {
    var exportData: {}[] = [];
    switch (type) {
      case 'speed':
        exportData = Object.entries(this.speedGraphic).map(([key, value]) => ({ Fecha: key, 'Max Velocidad': value }));
        break;
      case 'speedDetail':
        exportData = this.rowDataSpeed.map((item: any) => {
          return {
            Fecha: item.dia,
            Patente: item.patente,
            'Max Velocidad': item.valor,
          };
        });
        break;
      case 'distance':
        exportData = Object.entries(this.distanceGraphic).map(([key, value]) => ({ Fecha: key, 'Kilómetros Recorridos': value }));
        break;
      case 'distanceDetail':
        exportData = this.rowDataDistance.map((item: any) => {
          return {
            Fecha: item.dia,
            Patente: item.patente,
            'Kilómetros Recorridos': item.valor,
          };
        });
        break;
      case 'useTime':
        exportData = Object.entries(this.timeGraphic).map(([key, value]) => ({ Fecha: key, 'Minutos': value }));
        break;
      case 'useTimeDetail':
        exportData = this.rowDataTime.map((item: any) => {
          return {
            Fecha: item.dia,
            Patente: item.patente,
            Minutos: item.valor,
          };
        });
        break;
      case 'ignition':
        //@ts-ignore
        exportData = Object.entries(this.ignitionGraphic).map(([key, value]) => ({ Fecha: key, 'Con Contacto': value.cc, 'Sin Contacto': value.sc }));
        break;
      case 'ignitionDetail':
        exportData = this.rowDataIgnition.map((item: any) => {
          return {
            Fecha: item.dia,
            Patente: item.patente,
            Evento: (item.tipo == 'cc'? 'CON CONTACTO' : 'SIN CONTACTO'),
            'Nro Eventos': item.valor,
          };
        });
        break;
      case 'alertGraph':
        exportData = Object.entries(this.alertGraphic).map(([key, value]) => ({ 'Nombre Alerta': key, 'Total': value}));
        break;
      case 'alertGraphDetail':
        exportData = this.rowDataAlert.map((item: any) => {
          return {
            'Nombre Alerta': item.alerta,
            'Tipo Alerta': item.tipo,
            Patente: item.unidad,
            Total: item.total,
          };
        });
        break;
    }
    switch (extension) {
      case 'csv':
        exportCsv(exportData, type);
        break;
      case 'xlsx':
        exportExcel(exportData, type);
        break;
      case 'json':
        exportJson(exportData, type);
        break;
    }
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
  }

  getUserID(): number {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  }

  getForListBar(
    data: any,
    labelName: string,
    valueName: string,
    graphRef: string
  ) {
    var labels: any = [];
    var values: any = [];
    for (let item in data) {
      labels.push(item);
      values.push(parseInt(data[item]));
    }
    return { labels: labels, values: values, ref: graphRef };
  }

  getForListLine(
    data: any,
    labelName: string,
    valueName: string,
    valueName2: string,
    graphRef: string
  ) {
    var labels: any = [];
    var values: any = [];
    var values2: any = [];
    for (var item in data) {
      labels.push(item);
      values.push(data[item]['cc']);
      values2.push(data[item]['sc']);
    }
    return { labels: labels, values: values, values2: values2, ref: graphRef };
  }

  fillData(type: any, data: any) {
    switch (type) {
      case 'ms_graph':
        this.speedGraphic = data;
        break;
      case 'ms_det':
        this.rowDataSpeed = data;
        break;
      case 'km_graph':
        this.distanceGraphic = data;
        break;
      case 'km_det':
        this.rowDataDistance = data;
        break;
      case 'hm_graph':
        this.timeGraphic = data;
        break;
      case 'hm_det':
        this.rowDataTime = data;
        break;
      case 'ig_graph':
        this.ignitionGraphic = data;
        break;
      case 'ig_det':
        this.rowDataIgnition = data;
        break;
      case 'a_graph':
        this.alertGraphic = data;
        break;
      case 'a_det':
        this.rowDataAlert = data;
        break;
    }
  }

  beforeMount() {
    this.mountGrid();
  }

  @Watch('speedGraphic')
  onSpeedChanged(value: string, oldValue: string) {
    this.mountGraphicSpeed();
  }
  @Watch('distanceGraphic')
  onDistanceChanged(value: string, oldValue: string) {
    this.mountGraphicDistance();
  }
  @Watch('timeGraphic')
  onTimeChanged(value: string, oldValue: string) {
    this.mountGraphicTime();
  }
  @Watch('ignitionGraphic')
  onIgnitionChanged(value: string, oldValue: string) {
    this.mountGraphicIgnition();
  }
  @Watch('alertGraphic')
  onAlertChanged(value: string, oldValue: string) {
    this.mountGraphicAlert();
  }

  @Watch('load')
  onLoadChanged(value: boolean, oldValue: boolean) {
    this.mountGraphicAlert();
    this.mountGraphicSpeed();
    this.mountGraphicDistance();
    this.mountGraphicTime();
    this.mountGraphicIgnition();
  }
  mountGrid() {
    this.columnDefsSpeed = [
      { field: 'dia', sortable: true, headerName: 'Fecha' },
      { field: 'patente', sortable: true, headerName: 'Patente' },
      { field: 'valor', sortable: true, headerName: 'Máxima Velocidad' },
    ];
    this.columnDefsDistance = [
      { field: 'dia', sortable: true, headerName: 'Fecha' },
      { field: 'patente', sortable: true, headerName: 'Patente' },
      {
        field: 'valor',
        sortable: true,
        headerName: 'Kilómetros Recorridos',
      },
    ];
    this.columnDefsTime = [
      { field: 'dia', sortable: true, headerName: 'Fecha' },
      { field: 'patente', sortable: true, headerName: 'Patente' },
      { field: 'valor', sortable: true, headerName: 'Minutos' },
    ];
    this.columnDefsIgnition = [
      { field: 'dia', sortable: true, headerName: 'Fecha' },
      { field: 'patente', sortable: true, headerName: 'Patente' },
      { field: 'tipo', sortable: true, headerName: 'Evento', cellRenderer: (r: any) => { return r=='cc' ? 'CON CONTACTO' : 'SIN CONTACTO'} },
      { field: 'valor', sortable: true, headerName: 'Nro Eventos' },
    ];
    this.columnDefsAlert = [
      { field: 'alerta', sortable: true, headerName: 'Nombre alerta' },
      { field: 'tipo', sortable: true, headerName: 'Tipo alerta' },
      { field: 'unidad', sortable: true, headerName: 'Unidad' },
      { field: 'total', sortable: true, headerName: 'Total' },
    ];
  }

  updateTags() {
    this.$nextTick(() => {
      this.patentValues.push(...this.search.split(','));
      this.$nextTick(() => {
        this.search = '';
      });
    });
  }

  formatDate(list: any) {
    return list.map(function (num: any) {
      return num.split(' ')[0];
    });
  }

  formatParseInt(number: string) {
    return number.split('.')[0];
  }

  mountGraphicIgnition() {
    var data = this.getForListLine(
      this.ignitionGraphic,
      'fecha',
      'totalconexion',
      'sinconexion',
      'Ignición'
    );
    (this.$refs.lineRefIgnicion as Line).renderChart(
      {
        labels: this.formatDate(data.labels),
        datasets: [
          {
            label: 'Con Contacto',
            data: data.values,
            borderColor: '#00FF00',
            fill: false,
          },
          {
            label: 'Sin Contacto',
            data: data.values2,
            borderColor: '#ff0000',
            fill: false,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.pluginOptions,
      }
    );
  }
  mountGraphicSpeed() {
    var data = this.getForListBar(
      this.speedGraphic,
      'fecha',
      'velocidad',
      'Velocidad Máxima'
    );
    (this.$refs.barRefSpeed as Bar).renderChart(
      {
        labels: this.formatDate(data.labels),
        datasets: [
          {
            label: data.ref,
            data: data.values,
            backgroundColor: '#d49231',
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.pluginOptions,
      }
    );
  }
  mountGraphicDistance() {
    var data = this.getForListBar(
      this.distanceGraphic,
      'fecha',
      'distancia',
      'Kilómetros Recorridos'
    );
    (this.$refs.barRefDistance as Bar).renderChart(
      {
        labels: this.formatDate(data.labels),
        datasets: [
          {
            label: data.ref,
            data: data.values,
            backgroundColor: '#e3e312',
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.pluginOptions,
      }
    );
  }
  mountGraphicTime() {
    var data = this.getForListBar(
      this.timeGraphic,
      'fecha',
      'total',
      'Tiempo de Uso (minutos)'
    );
    (this.$refs.barRefTime as Bar).renderChart(
      {
        labels: this.formatDate(data.labels),
        datasets: [
          {
            label: data.ref,
            data: data.values,
            backgroundColor: '#2a84de',
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.pluginOptionsTime,
      }
    );
  }
  mountGraphicAlert() {
    var data = this.getForListBar(
      this.alertGraphic,
      'nombrealerta',
      'total',
      'Alerta'
    );
    (this.$refs.barRefAlert as Bar).renderChart(
      {
        labels: data.labels,
        datasets: [
          {
            label: data.ref,
            data: data.values,
            backgroundColor: '#e3abdb',
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.pluginOptions,
      }
    );
  }

  created(): void { }

  mounted(): void {
    this.loadGraphicFetch();
    this.mountGrid();
    (this.$refs.barRefAlert as Bar).addPlugin(ChartDataLabels);
    (this.$refs.barRefSpeed as Bar).addPlugin(ChartDataLabels);
    (this.$refs.barRefDistance as Bar).addPlugin(ChartDataLabels);
    (this.$refs.barRefTime as Bar).addPlugin(ChartDataLabels);
    (this.$refs.lineRefIgnicion as Line).addPlugin(ChartDataLabels);
  }

  clearGraphics() {
    this.alertGraphic = [];
    this.mountGraphicAlert();
    this.speedGraphic = [];
    this.mountGraphicSpeed();
    this.distanceGraphic = [];
    this.mountGraphicDistance();
    this.timeGraphic = [];
    this.mountGraphicTime();
    this.ignitionGraphic = [];
    this.mountGraphicIgnition();
    this.rowDataSpeed = [];
    this.rowDataDistance = [];
    this.rowDataTime = [];
    this.rowDataIgnition = [];
    this.rowDataAlert = [];
  }
}
